// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"e2ce354a","764":"14d9a982"}[chunkId] + ".chunk.css";
};